import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';

const CATEGORIES = ['life', 'love', 'work', 'dreams', 'fears', 'memories', 'philosophy', 'random', 'rant', 'confession'];

function TopicEditor() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: '', content: '', category: '', tags: '', mood: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id) {
      api.get(`/topics`).then(({ data }) => {
        const topic = data.topics.find(t => t.id === parseInt(id));
        if (topic) {
          setForm({
            title: topic.title,
            content: topic.content,
            category: topic.category || '',
            tags: topic.tags ? topic.tags.join(', ') : '',
            mood: topic.mood || ''
          });
        }
      });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);

    const payload = {
      title: form.title,
      content: form.content,
      category: form.category || null,
      tags: form.tags.split(',').map(t => t.trim()).filter(Boolean),
      mood: form.mood || null
    };

    try {
      if (id) {
        await api.put(`/topics/${id}`, payload);
      } else {
        await api.post('/topics', payload);
      }
      navigate('/admin/topics');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="admin-header">
        <h1>{id ? 'Edit Thought' : 'New Thought'}</h1>
      </div>

      {error && <div className="error-msg">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            className="form-input"
            style={{ fontFamily: 'var(--font-serif)', fontSize: '1.4rem', background: 'transparent', padding: '0 0 12px' }}
            placeholder="title this thought..."
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            required
          />
        </div>

        <div className="form-group">
          <textarea
            className="form-input"
            placeholder="let it flow..."
            value={form.content}
            onChange={(e) => setForm({ ...form, content: e.target.value })}
            required
            rows={12}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px' }}>
          <div className="form-group">
            <label className="form-label">Category</label>
            <select className="form-input" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>
              <option value="">pick one...</option>
              {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Mood</label>
            <select className="form-input" value={form.mood} onChange={(e) => setForm({ ...form, mood: e.target.value })}>
              <option value="">...</option>
              {['raw', 'peaceful', 'heavy', 'light', 'angry', 'hopeful', 'lost', 'clear'].map(m => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Tags</label>
            <input
              type="text" className="form-input"
              placeholder="growth, pain"
              value={form.tags}
              onChange={(e) => setForm({ ...form, tags: e.target.value })}
            />
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? '...' : (id ? 'Update' : 'Publish')}
          </button>
          <button type="button" className="btn btn-ghost" onClick={() => navigate('/admin/topics')}>Cancel</button>
        </div>
      </form>
    </div>
  );
}

export default TopicEditor;
